var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"216":1,"270":1,"409":1,"659":1,"676":1,"712":1,"789":1,"843":1,"857":1,"1004":1,"1005":1,"1132":1,"1435":1,"1567":1,"1595":1,"1821":1,"1924":1,"1978":1,"2041":1,"2044":1,"2055":1,"2192":1,"2242":1,"2273":1,"2305":1,"2316":1,"2325":1,"2333":1,"2406":1,"2621":1,"2622":1,"2690":1,"2718":1,"2950":1,"2985":1,"3011":1,"3054":1,"3085":1,"3283":1,"3347":1,"3578":1,"3601":1,"3658":1,"3840":1,"3904":1,"4004":1,"4174":1,"4306":1,"4362":1,"4450":1,"4579":1,"4619":1,"4728":1,"4731":1,"4754":1,"4854":1,"4919":1,"4930":1,"4996":1,"5002":1,"5010":1,"5209":1,"5227":1,"5365":1,"5427":1,"5501":1,"5542":1,"5546":1,"5970":1,"6032":1,"6039":1,"6124":1,"6397":1,"6443":1,"6687":1,"6703":1,"6926":1,"6949":1,"7142":1,"7249":1,"7282":1,"7326":1,"7353":1,"7404":1,"7567":1,"8081":1,"8134":1,"8139":1,"8260":1,"8298":1,"8310":1,"8440":1,"8458":1,"8663":1,"8727":1,"8757":1,"8777":1,"8824":1,"8916":1,"9007":1,"9036":1,"9080":1,"9105":1,"9108":1,"9175":1,"9229":1,"9516":1,"9608":1,"9861":1,"9994":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr